import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";

import { authClient } from "../shared/lib/auth-client";

/**
 * Pathless layout route: contributes nothing to the URL, but every child is
 * gated on a session. The redirect happens in beforeLoad, so an unauthenticated
 * visitor never renders a protected route or fires its loader.
 */
export const Route = createFileRoute("/_authenticated")({
  beforeLoad: async ({ location }) => {
    const { data } = await authClient.getSession();
    if (!data) {
      throw redirect({
        to: "/auth",
        search: { redirect: location.href },
      });
    }
    return { user: data.user };
  },
  component: () => <Outlet />,
});
